import React from 'react';
import { FormattedMessage } from 'react-intl';
import onboardingInfoBox from 'contest/components/onboarding-prompts/onboardingInfoBox';

export default onboardingInfoBox('final-round', () => (
    <div className="info-box__content">
        <div className="info-box__title">
            <FormattedMessage id="infobox_title" />
        </div>
        <FormattedMessage id="infobox_text" />
    </div>
));



// WEBPACK FOOTER //
// ./src/web/js/contest/components/onboarding-prompts/FinalRoundInfoBox.js